import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IGroupAddress } from '../Types';

const RESOURCE = 'addresses';

interface ICreateAddress extends Omit<IUri, 'resource'> {
  body: Partial<IGroupAddress>;
  token: string;
}

interface ICreateAddressResponse extends IHttpResponse {
  body?: IGroupAddress;
}

export default ({
  body,
  token,
}: ICreateAddress): Promise<ICreateAddressResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
  });

  return BaseService.Post({ url, token, data: body });
};
